import type { NavigateFunction, NavigateOptions, To } from "react-router-dom";

export const History = {
    navigate: null as NavigateFunction | null,
    push: (page: To, options?: NavigateOptions) => History.navigate?.(page, options),
};
